/**************************************************
 * Nombre:       Home_Habitaciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../../Constantes";
import {theme} from "../../../Tema";
import ic_punto from '../../../Recursos/ic_punto.svg'
import foto from '../../../Recursos/tmp_habitacion.png'
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Home_Habitaciones = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#080A44'}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={8}
                    >


                        <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={0}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography
                                        sx={{
                                            fontFamily: NEGRITA,
                                            fontSize: sCell ? 40 : 48,
                                            fontWeight: 600,
                                            color: theme.palette.primary.main
                                        }}>Habitaciones</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography
                                        sx={{fontSize: 18, fontWeight: 400}}>Nuestras habitaciones están
                                        diseñadas para brindar amplitud y comodidad, ideales tanto para el viajero de
                                        negocios
                                        como para el turista, en el ambiente tranquilo del Hotel Mar Azul.</Typography>
                                </Grid>

                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    sx={{mt: 2}}
                                >

                                    {items.map((item, i) => (
                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <Typography sx={{fontWeight: 600, fontSize: 16}}>
                                        <span>
                                        <img src={ic_punto} width={8} height={'auto'}
                                             style={{marginTop: -1, marginBottom: 1, marginRight: 5}}/>
                                        </span>
                                                {item}
                                            </Typography>
                                        </Grid>
                                    ))}

                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 4}}>
                                    <Button variant={'outlined'}>RESERVAR HABITACION</Button>
                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{justifyContent: 'flex-start'}}>
                            <Splide
                                //ref={refe}
                                aria-label="My Favorite Images" style={{width: '100%'}}
                                options={{
                                    autoplay: true,
                                    speed: 1500,
                                    rewind: true,
                                    perPage: 1,
                                    arrows: true,
                                    perMove: 1,
                                    pagination: true,
                                    width: '100%',
                                    drag: 'free',
                                    snap: true,
                                    interval: 5000,
                                    noDrag: true,
                                    focus: 'center',
                                    type: 'loop',
                                    padding: '0rem',
                                    gap: 20,

                                }}
                            >

                                {imagenes.map((item, index) => {
                                    return (
                                        <SplideSlide key={`qer${index}`}>
                                            <img src={item} width={'100%'} height={'auto'}
                                                 style={{borderRadius: 8, border: 0, borderColor: '#000'}}/>
                                        </SplideSlide>
                                    )
                                })}


                            </Splide>
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Home_Habitaciones

const items = ['Camas Dobles', 'Aire Acondicionado', 'Aseo Constante', 'Parqueadero Gratuito']

const imagenes = [foto, foto, foto, foto]